/* eslint-disable camelcase */
import { parseQuery } from './utils/index';

import * as dingTalk from './utils/dingtalk-params';
import { dingTalkApi } from './utils/dingtalk-api';

import dd from 'dingtalk-jsapi';

import cookie from 'js-cookie';

import {
  IS_DEBUG,
  IS_DINGTALK,
  IS_IOS,
  IS_IE,
  IS_WECHAT,
  IS_WECHAT_ALL,
  IS_WECHAT_PC_MAC,
  IS_WECHAT_PC_WINDOW,
  isPC
} from './is-platform';

import { PlatformServiceLike, BrowserService } from './platform-service';

// import { DingTalkService } from './dingtalk/dingtalk-service';

import { Base64 } from 'js-base64';

function parseToken (token: string) {
  const useInfoBs: string = token.split('.')[1];
  const useInfo = JSON.parse(Base64.decode(useInfoBs));
  return useInfo;
}

let service: PlatformServiceLike = new BrowserService();

async function init (clientId: string = 'api', scope: string = 'read') {
  console.log('钉钉微信免登初始化-----', clientId, scope);

  let _service: PlatformServiceLike | null = null;

  let queryUrl = location.href;

  if (IS_WECHAT && location.search.indexOf('code=') >= 0) {
    const { href, search } = window.location;
    const originUrl = href.split(search).join('');
    if (originUrl.indexOf('?') < 0) {
      queryUrl = href.split(search).join('') + search;
    } else {
      queryUrl = href.split(search).join('') + '&' + search.split('?')[1];
    }
    window.location.href = queryUrl;
    return;
  }

  const query = parseQuery();

  let p: Promise<dingTalk.LoginResult> | null = null;
  const localStorageKey = 'SIGNATURE_INFO';
  const localStorageSignature = localStorage.getItem(localStorageKey);
  // 清理cookie
  cookie.remove('tenantCode');

  if (IS_DINGTALK) {
    const dingtalk = await import('./dingtalk');
    p = dingtalk.init(clientId, scope, query) as any;
    _service = new dingtalk.DingTalkService();
  } else if (IS_WECHAT) {
    console.log('🚀 ~ file: index.ts ~ line 92 ~ init ~ IS_WECHAT', IS_WECHAT);
    console.log('🚀 ~ file: index.ts ~ line 96 ~ init ~ clientId', clientId);
    // 企业微信统一配置pc端地址，在此判断是否跳转至移动端
    const wechat = await import('./wechat');
    p = wechat.init(clientId, scope, query) as any;
    _service = new wechat.WechatService();
  }

  if (_service) {
    service = _service;
  }

  if (p && !localStorageSignature) {
    const res: any = await p;
    if (res) {
      // console.log("res", res.data);
      const {
        access_token, refresh_token, expiration, tenants
      } = res.data;

      window.localStorage.setItem('token', access_token);
      // 请求图片需要 cookie
      cookie.set('access_token', access_token, {
        expires: new Date(expiration)
      });
      tenants &&
        window.localStorage.setItem('tenants', JSON.stringify(tenants));
      const tenantCode = query.tenantCode;
      if (tenantCode) {
        window.sessionStorage.setItem('tenantCode', tenantCode);
        cookie.set('tenantCode', tenantCode);
      }

      // loginInfo = res;
      const loginInfoRes: any = await dingTalkApi.getLoginInfo();
      let deptinfo: any = {};

      if (loginInfoRes.success && loginInfoRes.data) {
        deptinfo = {
          id: loginInfoRes?.data?.mainDepartmentId,
          name: loginInfoRes?.data?.mainDepartmentName
        };
      }

      const info = parseToken(access_token);
      if (info) {
        const user = loginInfoRes as any;
        user.isAppAdmin = info.isAppAdmin;
        user.isAdmin = info.isAdmin;
      }

      const user = {
        userInfo: {
          id: loginInfoRes.id,
          name: loginInfoRes.name,
          username: loginInfoRes.username
        },
        departmentInfo: {
          id: deptinfo.id,
          name: deptinfo.name
        }
      };

      window.sessionStorage.setItem('user', JSON.stringify(user));
      window.localStorage.setItem('user', JSON.stringify(user));
      // localStorage.setItem('loginInfo', JSON.stringify(loginInfo));
    }
  } else {
    if (query.access_token) {
      window.localStorage.setItem('token', query.access_token);
    }
  }

  return {
    query
    // loginInfo,
  };
}

async function getPlaformService () {
  // 调用原生能力的时候, 已经鉴权过一次，只需要获取对应的service 即可
  // const query = parseQuery();
  let platformService = new BrowserService();
  if (IS_DINGTALK) {
    const dingtalk = await import('./dingtalk');
    // await dingtalk.init(clientId, scope, query);
    platformService = new dingtalk.DingTalkService();
  } else if (IS_WECHAT_ALL) {
    const wechat = await import('./wechat');
    // await wechat.init(clientId, scope, query);
    platformService = new wechat.WechatService();
  }
  return platformService;
}

async function wechatAuth () {
  // 仅在wechat 环境下使用, 不通过wechat 登陆应用
  if (IS_WECHAT_ALL) {
    const wechat = await import('./wechat');
    wechat.initExtra();
  }
}
const dingTalkInit = init;

export {
  IS_DEBUG,
  IS_DINGTALK,
  IS_IOS,
  IS_IE,
  IS_WECHAT,
  IS_WECHAT_ALL,
  IS_WECHAT_PC_MAC,
  IS_WECHAT_PC_WINDOW,
  service,
  getPlaformService,
  wechatAuth,
  dingTalkInit,
  dd,
  isPC
};
